import { render, staticRenderFns } from "./MaterialStockPreview.vue?vue&type=template&id=5b7ccd68&"
import script from "./MaterialStockPreview.vue?vue&type=script&lang=js&"
export * from "./MaterialStockPreview.vue?vue&type=script&lang=js&"
import style0 from "./MaterialStockPreview.vue?vue&type=style&index=0&id=5b7ccd68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports